import { connect } from 'react-redux';
import { addContentFavorite, removeContentFavorite } from '../../app/actions/spaces/FavoritesActions';
import { populateContentBreadcrumbs } from '../../app/content/breadcrumbs/BreadcrumbHelpers';
import { CompositeSessionInfoSelectors } from '../../app/selectors/SessionInfoSelectors';
import { siteUrlsSelector } from '../../app/selectors/SiteUrlsSelectors';
import { FlowSubspaceName } from '../../app/state/SpaceInfo';
import { MapDispatchToProps, MapStateToProps } from '../../app/utils/ConnectUtils';
import { selectCatalogingOnSiteEnabled } from '../../catalog/selectors/CatalogSelectors';
import { enterFlowSubspace } from '../actions/EnterFlowSubspaceAction';
import { FlowSpace, FlowSpaceDispatchProps, FlowSpaceOwnProps, FlowSpaceStateProps } from './FlowSpace';

const mapStateToProps: MapStateToProps<FlowSpaceStateProps> = (state) => ({
  catalogingOnSiteEnabled: selectCatalogingOnSiteEnabled(state),
  urls: siteUrlsSelector(state),
  areUsersVisible: !CompositeSessionInfoSelectors.isLimitedUserVisibilityEnforced(state)
});

const mapDispatchToProps: MapDispatchToProps<FlowSpaceDispatchProps, FlowSpaceOwnProps> = (dispatch, ownProps) => ({
  enterSpace: () => {
    dispatch(enterFlowSubspace(ownProps.flowDetailInfo, ownProps.subplaceName as FlowSubspaceName));
  },
  addToFavorites: () => {
    dispatch(addContentFavorite(ownProps.flowDetailInfo));
  },
  removeFromFavorites: () => {
    dispatch(removeContentFavorite(ownProps.flowDetailInfo));
  },
  populateContentBreadcrumbs,
});

export const ConnectedFlowSpace = connect(mapStateToProps, mapDispatchToProps)(FlowSpace);
